<template>
	<div class="day-single" v-if="uiReady">
		<div class="day-single__back">
			<router-link :to="{name: 'DayView'}">
				<img src="@/assets/arrow-back.svg" class="mr-10" />
				{{ getScenarios.scenario.name }}
			</router-link>
		</div>
		<div class="w-100 text-center mt-30 mb-20">
			<c-score-modal @onSuccess="onScoreAdded" :title="getScenarios.scenario.name" />
		</div>
		<div class="day-single__info" v-show="type === 1">
			<c-title bg="FAFF00" size="32" class="mt-20">
				<img src="@/assets/map.svg" class="mr-10 ml-5" />
				6397-9045-0000
			</c-title>
			<div class="day-single__content mt-40" v-html="convertText(getScenarios.scenario.content)">
			</div>
		</div>
		<div class="day-single__history" v-show="type === 2">
			<div class="scores-list">
				<div class="scores-list__item" v-if="getScenarios.userScenario.lastScore >= 0">
					<div>
						Last score
					</div>
					<div>
						{{ getScenarios.userScenario.lastScore }}
					</div>
				</div>
				<div class="scores-list__item" v-if="todayAvg >= 0">
					<div>
						Today avg. score
					</div>
					<div>
						{{ todayAvg.toFixed(1) }}
					</div>
				</div>
				<div class="scores-list__item" v-if="alltimeAvg>= 0">
					<div>
						All time avg. score
					</div>
					<div>
						{{ alltimeAvg.toFixed(1) }}
					</div>
				</div>
				<div class="scores-list__item" v-if="getScenarios.userScenario.bestScore >= 0">
					<div>
						Your best score
					</div>
					<div>
						{{ getScenarios.userScenario.bestScore }}
					</div>
				</div>
				<div class="scores-list__item" v-if="getScenarios.userScenario.timesDone >= 0">
					<div>
						Number of times done
					</div>
					<div>
						{{ getScenarios.userScenario.timesDone }}
					</div>
				</div>
			</div>
			<div class="fs-18 mt-30 fw-800">
				Last 7 scores
			</div>
			<apexchart ref="chartDay" :options="optionsDay" :series="seriesDay"></apexchart>
			<div class="fs-18 mt-30 fw-800">
				Last 7 days (average score)
			</div>
			<apexchart ref="chart" :options="options" :series="series"></apexchart>
			<table class="mt-30 score-table"
			       v-if="getScenarios.userScenario.days && getScenarios.userScenario.days.length">
				<tr v-for="(item, idx) in getArray(getScenarios.userScenario.days, 20)" :key="idx">
					<td>{{ item.day | moment('DD MMMM') }}</td>
					<td>{{ item.score.toFixed(2) }} avg score</td>
					<td>{{ item.timesDone }} {{ item.timesDone > 1 ? 'times': 'time' }}</td>
				</tr>
			</table>
		</div>
		<div class="day-single__nav">
			<div class="day-single__nav-item"
			     :class="{'active': type === 1}"
			     @click="toggleTab(1)">
				<img src="@/assets/info.svg"/>
				Info
			</div>
			<div class="day-single__nav-item"
			     :class="{'active': type === 2}"
			     @click="toggleTab(2)">
				<img src="@/assets/history.svg"/>
				History
			</div>
		</div>
	</div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';
import { mapGetters } from 'vuex';

export default {
	components: {
		'c-score-modal': () => import('@/components/modal'),
		apexchart: VueApexCharts,
	},
	data() {
		return {
			type: 1,
			options: {
				chart: {
					id: 'vuechart',
					zoom: {
						enabled: false,
					},
				},
				legend: {
					show: false,
				},
				xaxis: {
					// type: 'datetime',
					labels: {
						formatter: (value) => this.$moment(value).format('DD MMMM'),
					},
				},
				yaxis: {
					labels: {
						formatter: (value) => Math.ceil(value).toFixed(),
					},
				},
				noData: {
					text: 'No data.',
				},
			},
			optionsDay: {
				chart: {
					id: 'vuechart',
					zoom: {
						enabled: false,
					},
				},
				legend: {
					show: false,
				},
				xaxis: {
					show: false,
					enabled: false,
				},
				yaxis: {
					labels: {
						formatter: (value) => Math.ceil(value).toFixed(),
					},
				},
				noData: {
					text: 'No data.',
				},
			},
			series: [{
				name: 'Score',
				data: [],
			}],
			seriesDay: [{
				name: 'Score',
				data: [],
			}],
			content: {},
			history: {},
			uiReady: false,
		};
	},
	computed: {
		...mapGetters(['getScenarios', 'getUser']),
		alltimeAvg() {
			if (this.getScenarios.userScenario.timesDoneScored === 0) return 0;
			return this.getScenarios.userScenario.sumScores
			/ this.getScenarios.userScenario.timesDoneScored;
		},
		todayAvg() {
			if (this.getScenarios.userScenario.days.length < 1
			|| this.getScenarios.userScenario.days[this.getScenarios.userScenario.days.length - 1]
				.day !== this.$moment(new Date()).format('YYYY-MM-DD')) {
				return 0;
			}
			return this.getScenarios.userScenario
				.days[this.getScenarios.userScenario.days.length - 1].score;
		},
	},
	methods: {
		getArray(arr, count = 10) {
			const tmp = [...arr];
			const array = tmp.sort((a, b) => new Date(b.day) - new Date(a.day));
			return array.slice(Math.max(tmp.length - count, 0));
		},
		convertText(str) {
			const txt = document.createElement('textarea');
			txt.innerHTML = str;
			return txt.value;
		},
		prepareData() {
			this.$store.dispatch('loadCurrentScenarios', { id: this.$route.params.id, query: this.$route.query })
				.then((resp) => {
					this.uiReady = true;
					setTimeout(() => {
						const tmp = [];
						const day = [];
						this.getArray(resp.userScenario.days, 7)
							.forEach((el) => tmp.push({ x: el.day, y: el.score }));

						resp.userScenario.scores.forEach((el) => day.push(el.score));

						this.$refs.chart.updateSeries([{ data: tmp.reverse() }]);
						this.$refs.chartDay.updateSeries([{ data: day.slice(Math.max(day.length - 7, 0)) }]);
					}, 400);
				});
		},
		onScoreAdded() {
			this.prepareData();
			this.type = 2;
		},
		toggleTab(tab) {
			if (this.type !== tab) {
				this.$ga.event('Skaavok', `Toggle tab ${tab === 1 ? 'info' : 'history'} tab`, this.getScenarios.scenario.name);
				this.type = tab;
			}
		},
	},
	mounted() {
		this.prepareData();
	},
	beforeDestroy() {
		this.$store.dispatch('clearScenarios');
	},
};
</script>

<style lang="scss">
	.day-single {
		padding: 70px 20px 20px;
		display: flex;
		flex-direction: column;

		&__back {
			font-size: 28px;
			font-family: 'Burbank Big Cd Bd', sans-serif;
			a{
				color: #111;
				text-decoration: none;
			}
		}

		&__nav{
			display: flex;
			flex-direction: row;
			position: fixed;
			bottom: 0;
			left: 0;
			right: 0;
			width: 100%;
			z-index: 10;
			&-item{
				width: 50%;
				text-align: center;
				padding: 20px 10px;
				color: #fff;
				font-size: 18px;
				font-weight: 800;
				background: #515151;
				display: flex;
				flex-direction: column;
				img{
					margin-bottom: 8px;
				}
				&:first-child{
					border-right: 1px solid rgba(255, 255, 255, .5);
				}
				&.active{
					background: #6f6f6f;
				}
			}
		}

		.scores-list{
			display: flex;
			flex-wrap: wrap;
			margin: 30px -5px 20px;
			&__item{
				width: calc( 50% - 10px );
				padding: 10px 15px;
				display: flex;
				flex-direction: column;
				margin: 5px;
				background: #515151;
				color: #fff;
				font-weight: bold;
				div{
					&:nth-child(1){
						font-size: 13px;
					}
					&:nth-child(2){
						font-size: 24px;
					}
				}
			}
		}

		.score-table{
			width: 100%;
			border-spacing: 0;
			margin-bottom: 5px;
			tr{
				td{
					padding: 3px 8px;
					border: 0;
					background: #C4C4C4;
					color: #000;
					font-weight: bold;
					border-bottom: 8px solid #fff;
					&:nth-child(2){
						text-align: center;
					}
					&:nth-child(3){
						text-align: right;
					}
				}
				&:nth-child(2n){
					td{
						background: #FFA800;
					}
				}
			}
		}
	}
</style>
